<template>
  <div class="announcement d-flex justify-center align-center">
    <video v-if="isVideo" class="video" :src="mediaSrc" autoplay loop muted></video>
    <div v-else class="image" :style="{ backgroundImage: mediaUrl }"></div>
  </div>
</template>

<script>
import { config } from '@/config';

export default {
  name: 'FullScreenImageService',

  props: {
    announcement: Object,
    isLandscape: Boolean,
    isParallel: Boolean,
    isPreview: Boolean,
  },

  computed: {
    serverUrl() {
      return config.serverUrl;
    },

    mediaUrl() {
      const imageUrl = this.announcement.announcementImage
        ? `url('${this.serverUrl}displays/images/${this.announcement.id}/${this.announcement.announcementImage.id}')`
        : undefined;
      return this.isPreview
        ? this.announcement.imageUrl
          ? `url('${this.announcement.imageUrl}')`
          : imageUrl
        : imageUrl;
    },

    mediaSrc() {
      return this.mediaUrl ? this.mediaUrl.replace(/url\(['"]?|['"]?\)/g, '') : '';
    },

    isVideo() {
      return (
        (this.announcement.imageUrl &&
          (this.announcement.imageUrl.startsWith('data:video') ||
            this.announcement.announcementImageIsVideo)) ||
        (this.announcement.announcementImage &&
          ['.mp4', '.avi', '.mkv'].includes(this.announcement.announcementImage.postfix))
      );
    },
  },
};
</script>

<style scoped>
.announcement {
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.parallel.landscape.announcement,
.parallel.portrait.announcement:not(:first-child) {
  border-left: var(--divider-size) solid var(--background-color);
}

.image {
  width: 100%;
  height: 100%;
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.video {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  width: auto;
  transform: translate(-50%, -50%);
  object-fit: contain;
}
</style>
